// Federal TD1 (same for every staff member) on the official CRA fillable PDF
import React from "react";
import FillableTaxFormPdf from "./FillableTaxFormPdf";

export default function TD1FillablePdf() {
  return (
    <FillableTaxFormPdf
      itemId="td1-tax"
      metaPath="/api/registration/me/td1-meta"
      templatePath="/api/registration/td1/template"
      prefillPath="/api/registration/me/td1-prefill"
      formLabel="TD1"
    />
  );
}
